export const isNewlyAdded = (sendDay: string) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const sendDayDate = new Date(sendDay).getTime();
  const now = new Date().getTime();
  return now - sendDayDate < oneDay;
};

export const isNewlyAddedTimeZone = (sendDay: string, days: number = 2) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const sendDayDate = new Date(sendDay).getTime();
  const now = new Date().getTime();
  const daysDifference = days * oneDay;
  return now - sendDayDate < daysDifference;
};

export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
